"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;
function join(...values) {
    return {
        with: (seperator) => values.filter(x => x).join(seperator)
    };
}
exports.join = join;
